import { connect } from 'react-redux';
import { VENUE_SERVICE_TYPES } from 'constants/logic';
import { providesService, isVenueDashboardSubtypeFoodAndBeverage } from 'helpers/ia-logic';
import { selectActiveVenue } from 'selectors/general';

import RatingsClassFilter from './RatingsClassFilter';
import { selectRatingsClasses, selectSelectedClassId } from './Ratings.selectors';
import { updateClass } from './Ratings.saga';

const mapStateToProps = state => {
  const { serviceTypes } = selectActiveVenue(state);
  const isVenueFoodAndBeverage = isVenueDashboardSubtypeFoodAndBeverage(selectActiveVenue(state));

  return {
    classes: selectRatingsClasses(state),
    offersAppointments: providesService({ serviceTypes }, VENUE_SERVICE_TYPES.APPOINTMENT),
    offersClasses: providesService({ serviceTypes }, VENUE_SERVICE_TYPES.CLASS),
    selectedClassId: selectSelectedClassId(state),
    isVenueFoodAndBeverage,
  };
};

const mapDispatchToProps = { updateClass };

export default connect(mapStateToProps, mapDispatchToProps)(RatingsClassFilter);
